import { createContext, useContext } from 'react'
import { SQLocalKysely } from 'sqlocal/kysely'
import { Kysely } from 'kysely'

export interface DbliteContextState<Db = unknown> {
  sqlite: SQLocalKysely
  db: Kysely<Db>
}

export const DBliteContext =
  createContext<DbliteContextState | null>(null)

/**
 * Hook to access the sqlite database instance
 * @throws Error if used outside of WaSqliteReactProvider
 */
export function useDblite(): DbliteContextState {
  const db = useContext(DBliteContext)
  if (!db) {
    throw new Error(
      'useDblite must be used within a DbliteProvider'
    )
  }
  return db
}

/**
 * Hook to access the sqlite database instance (optional version)
 */
export function useDbliteOptional(): DbliteContextState | null {
  return useContext(DBliteContext)
}
